import React from "react";
import {Box, useMediaQuery} from "@mui/system";
import {Typography} from "@mui/material";

import {theme} from "../../../../../utils";
import {ResourceItemType, ResourceListType, styles} from "./resourceList-helpers";
import {DownloadButton, DownloadButtonType} from "../../../../../components";

export const ResourceList = (props: ResourceListType) => {
    const {listItems, buttonText, buttonIcon} = props;
    const isMobileX = useMediaQuery(theme.breakpoints.down(600))

    return (
        <Box sx={styles.listContainer}>
            {listItems.map((item:ResourceItemType, index: number) => {
                return (
                    <Box key={index + 1} sx={styles.itemListWrapper}>
                        <Box sx={isMobileX ? { ...styles.mobileWrapper } : styles.listRow}>
                            <Typography sx={styles.listTitle}>
                                {item.title}
                            </Typography>
                            <DownloadButton fileUrl={item?.fileUrl} buttonIcon={buttonIcon} buttonText={buttonText} buttonType={DownloadButtonType.Pdf} />
                        </Box>
                    </Box>
                )
            })}
        </Box>
    )
}